import React, {Component} from 'react';
import ApplicationStateHandler from "../../../lib/applications/application-state-handler";
import ApplicationApi from "../../../lib/applications/application-api";
import AlertManager from "../../../managers/alert/alert-manager";
import {Layout, MinMaxLayout} from "../../../layouts";
import GrantsApplicationPage from "../grants-application-page";
import ReactDOM from "react-dom";

class GrantsPreview extends Component {

    constructor(props) {
        super(props);

        this.state = {
            values: {},
            loaded: false,
            completed_sections: [],
            application: null,
            complete: false
        };
    }

    componentDidMount() {
        this.stateHandler = new ApplicationStateHandler();
        window.grantsPreview = true;
        this.stateHandler.setOnStateUpdate((state, callback ) => {
            this.setState(state, () => {
                if(callback) {
                    callback();
                }
            });
        });

        this.getApplication();



    }

    getApplication() {
        const raw = this.props.application;
        const parsed = JSON.parse(raw);

        this.setState({
            application : parsed.data
        }, () => {
            this.stateHandler.setStateFromApplication(this.state, parsed.data)
        });
    }

    onSave() {
        AlertManager.success('Progress will not be saved in preview mode!');
    }

    handleErrors(err, msg) {
        if (err.length > 0) {
            AlertManager.error(err[0][0]);
        } else {
            AlertManager.error(err);
        }

        const error = new Error(msg);

        window.Bugsnag?.leaveBreadcrumb(msg, err);
        window.Bugsnag?.notify(error);
    }

    handleSubmit(finalParams) {

        this.setState({complete : true});
        window.parent.postMessage('complete', '*');

    }

    handleQuestionChange(sectionId, blockId, questionId, value) {

        this.stateHandler.setQuestionValueState(this.state, sectionId, blockId, questionId, value);
    }

    getQuestionValue(sectionId, blockId, questionId) {


        return this.stateHandler.getQuestionValue(this.state, sectionId, blockId, questionId);
    }

    handleSectionComplete(completed, sectionId) {

        if (completed === true) {
            this.stateHandler.completeSection(this.state, sectionId, () => {
                this.onSave();
            });
        }

        if (completed === false) {
            this.stateHandler.unCompleteSection(this.state, sectionId);
        }

    }


    render() {


        return (
            <Layout hideTop={true} className={'full'}>
                <div style={{width: '100%', 'display': 'flex', justifyContent: 'center'}}>
                    {
                        (this.state.complete === false && this.state.application) &&
                        <GrantsApplicationPage
                            disableActions={true}
                            loaded={this.state.loaded}
                            onSubmit={this.handleSubmit.bind(this)}
                            onSectionComplete={this.handleSectionComplete.bind(this)}
                            completedSections={this.state.completed_sections}
                            application={this.state.application}
                            handleQuestionChange={this.handleQuestionChange.bind(this)}
                            getQuestionValue={this.getQuestionValue.bind(this)}
                            onSave={this.onSave.bind(this)}
                            getApplication={this.getApplication.bind(this)}
                        />
                    }
                    {
                        this.state.complete === true &&
                        <div style={{width: '100%', height: 'calc(100vh - 95px)', display : "flex", justifyContent: 'center', alignItems :'center', flexDirection: 'column'}}>
                                <h1>Congratulations!</h1><br/>
                                <h3>You have completed the Application Process. Please refresh the preview to restart the application.</h3>
                        </div>
                    }
                </div>

            </Layout>
        );
    }
}

export default GrantsPreview;


const el = document.getElementById('grants-preview-component');


if (el) {


    const data = el.getAttribute('data-application');

    ReactDOM.render(<GrantsPreview application={data}/>, el);
}
